// extracted by mini-css-extract-plugin
export default {"partnerWrapper":"PartnerPage_partnerWrapper__49S1+","partnerGrid":"PartnerPage_partnerGrid__y5Ko9","partnerItem":"PartnerPage_partnerItem__pDapE"};